/**
 * Bridge so dock artifact-reduction state can drive the review waveform path.
 * Raw buffers stay untouched; consumers apply a display-only transform.
 */

import type { ArtifactReductionState } from "./artifactQcTypes";
import type { ClassifiedArtifact } from "./artifactClassification";

export type ArtifactReductionDisplaySnapshot = {
  state: ArtifactReductionState;
  artifacts: ClassifiedArtifact[];
  updatedAtIso: string;
};

type Listener = (snapshot: ArtifactReductionDisplaySnapshot | null) => void;

let snapshot: ArtifactReductionDisplaySnapshot | null = null;
const listeners = new Set<Listener>();

export function setArtifactReductionDisplaySnapshot(
  next: ArtifactReductionDisplaySnapshot | null,
): void {
  snapshot = next;
  for (const listener of listeners) listener(snapshot);
}

export function getArtifactReductionDisplaySnapshot(): ArtifactReductionDisplaySnapshot | null {
  return snapshot;
}

export function subscribeArtifactReductionDisplay(listener: Listener): () => void {
  listeners.add(listener);
  listener(snapshot);
  return () => {
    listeners.delete(listener);
  };
}

export function isArtifactReductionDisplayActive(
  snap: ArtifactReductionDisplaySnapshot | null = snapshot,
): boolean {
  return Boolean(
    snap?.state.enabled &&
      !snap.state.showOriginalSignal &&
      snap.state.reducedTypes.length > 0,
  );
}
